<template>
  <div class="publication-member-slider">
    <Swiper
      v-bind="settings"
    >
      <SwiperSlide v-for="item in result">
        <PublicationMemberItem :result="item"/>
      </SwiperSlide>
    </Swiper>
  </div>
</template>

<script>
import {Swiper, SwiperSlide} from 'swiper/vue';

export default {
  name: 'PublicationMemberSlider',
  props: ['result'],
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    const settings = {
      // spaceBetween: 32,
      // slidesPerView: 3.4,
      // centeredSlides: true,
      // loop: true,
      breakpoints: {
        320: {
          slidesPerView: 1.2,
          spaceBetween: 19,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 19,
        },
        1024: {
          spaceBetween: 29,
          slidesPerView: 4,
        }
      },
    }

    return {
      settings
    }
  }
}
</script>

<style lang="scss" scoped>
.publication-member-slider {

}
</style>